import React, { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { MdOutlineAddShoppingCart } from 'react-icons/md';
import Toast from '../common/Toast';
import { useDispatch } from 'react-redux';
import { addCart, deleteCart } from '../../store/actions';

const Wrapper = styled.div`
  padding: 10px;
`;

const ThumbnailWrap = styled.div`
  position: relative;
  width: 200px;
  height: 200px;
`;

const Thumbnail = styled.img`
  width: 200px;
  height: 200px;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  object-fit: contain;
  background: #fafafa;
`;

const DimOverlay = styled.div`
  position: absolute;
  inset: 0;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const DimLabel = styled.span`
  padding: 4px 14px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 700;
  background: #dc2626;
  color: #fff;
`;

const StockBadge = styled.span`
  position: absolute;
  top: 8px;
  right: 8px;
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  background: #2563eb;
  color: #fff;
  z-index: 1;
`;

const Content = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 10px;
`;

const TextBox = styled.div`
  width: 170px;
  display: flex;
  flex-direction: column;
`;

const Text = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 1.4;
  color: #333;
`;

const SubText = styled.div`
  font-weight: 700;
  font-size: 14px;
  color: #111;
  margin-top: 4px;
`;

const Badge = styled.span`
  display: inline-block;
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 700;
  margin-right: 4px;
  vertical-align: middle;
  background: ${({ $type }) =>
    ($type === 'sold_out' || $type === 'discontinued') ? '#fef2f2' : '#eff6ff'};
  color: ${({ $type }) =>
    ($type === 'sold_out' || $type === 'discontinued') ? '#dc2626' : '#2563eb'};
`;

const dimLabel = { sold_out: '품절', discontinued: '단종' };

const StockInfo = ({ product }) => {
  const status = product.stock_status;
  const qty = product.stock_quantity;
  if (status === 'sold_out') return <Badge $type="sold_out">품절</Badge>;
  if (status === 'discontinued') return <Badge $type="discontinued">단종</Badge>;
  if (qty != null && qty > 0 && qty <= 5) return <Badge $type="low">재고 {qty}개</Badge>;
  return null;
};

const ProductContainer = ({ product, level }) => {
  let price = product[level];
  price = price;
  const dispatch = useDispatch();
  const [toast, setToast] = useState(false);
  const _handleClick = () => {
    setToast(!toast);
  };
  return (
    <>
      {product && level && (
        <Wrapper>
          <Link to={`/product/detail/${product._id}`}>
            <ThumbnailWrap>
              <Thumbnail src={product.img} />
              {product.stock_quantity != null && product.stock_quantity > 0 &&
                product.stock_status !== 'sold_out' && product.stock_status !== 'discontinued' && (
                <StockBadge>잔여 {product.stock_quantity}개</StockBadge>
              )}
              {(product.stock_status === 'sold_out' || product.stock_status === 'discontinued') && (
                <DimOverlay>
                  <DimLabel>{dimLabel[product.stock_status]}</DimLabel>
                </DimOverlay>
              )}
            </ThumbnailWrap>
          </Link>
          <Content>
            <TextBox>
              <Link to={`/product/detail/${product._id}`}>
                <div>
                  <StockInfo product={product} />
                </div>
                {product.product_name.length > 38 ? (
                  <Text>{product.product_name.slice(0, 38) + '...'}</Text>
                ) : (
                  <Text>{product.product_name}</Text>
                )}
                <SubText>{price.toLocaleString('ko-KR')}원</SubText>
              </Link>
            </TextBox>
            <MdOutlineAddShoppingCart
              onClick={() => {
                _handleClick();
                dispatch(addCart(level, product));
              }}
              size="22"
              cursor="pointer"
              color="#2563eb"
              style={{ marginTop: 2, flexShrink: 0 }}
            />
          </Content>
          {toast && (
            <Toast _handleToast={_handleClick}>
              제품이 장바구니에 담겼습니다
            </Toast>
          )}
        </Wrapper>
      )}
    </>
  );
};

export default ProductContainer;
